import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#193a6f',
      light: '#4264a0',
      dark: '#001442',
    },
    secondary: {
      main: '#f98125',
      light: '#ffb255',
      dark: '#c15200',
    },
  },
  components: {
    MuiModal: {
      styleOverrides: {
        root: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          borderRadius: '8px',
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '16px',
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          padding: '8px 24px',
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#4264a0',
          }
        }
      }
    }
  }
});

// Centralized styles that can be used across components
export const commonStyles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    padding: '24px',
    maxHeight: '90vh',
    overflow: 'auto',
    width: '80%',
    maxWidth: '800px',
    position: 'relative',
  },
  formControl: {
    width: '100%',
    marginBottom: '16px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '16px',
    marginTop: '24px',
  },
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white",
    marginLeft: "auto",
    textDecoration: "none",
  },
  logo: {
    maxWidth: 160,
  },
  formControl: {
    margin: theme => theme.spacing(1),
    minWidth: 120,
  },
  buttonPanel: {
    display: "flex",
    gap: "1rem",
    justifyContent: "flex-end",
    marginTop: "2rem",
  },
  authContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '20px',
  },
  authCard: {
    maxWidth: '400px',
    width: '100%',
    padding: '24px',
    borderRadius: '8px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
  },
  authForm: {
    width: '100%',
    marginTop: '16px',
  },
  authSubmit: {
    margin: '24px 0 16px',
  },
  authError: {
    marginBottom: '16px',
    width: '100%',
  }
}; 